var map = {
	"./WorksWall.webp": "2a59",
	"./dreamroom_thumbnail.webp": "21e8",
	"./dynamicmaschines_thumbnail.webp": "b2a9",
	"./sunrise_thumbnail.webp": "69dc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8fbe";